import React from "react";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import CommingSoon from "../Components/CommingSoon";

const Shipping = () => {
    return (
        <div className="row">
            <div className="col-1 leftcol">
                {/* <HomeLeft /> */}
            </div>
            <div className="col-10 middlecol">
                <CommingSoon />
            </div>
            <div className="col-1 rightcol">
                {/* <HomeRight /> */}
            </div>
        </div>
    );
};

export default Shipping;